module.exports = __webpack_public_path__ + "img/09_my_42px_42px_00.f0f4d812.png";